import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ContratoService } from 'src/app/clientes/crear-contrato/contrato.service';

@Component({
  selector: 'app-prorrogas',
  templateUrl: './prorrogas.component.html',
  styleUrls: ['./prorrogas.component.scss']
})
export class ProrrogasComponent implements OnInit{
  prorrogasForm = this.fb.group({
    fec_inicio :[null],
    fec_fin : [null, Validators.required]
  });

  recurso = "contratos/admincontrato/";
  columns = ["numero", "fecha inicio", "fecha fin"]  ;
  params;
  nombre_tabla = 'prorrogas_contrato';
  target;

  constructor(private fb: FormBuilder,
              public contrato_serv : ContratoService) {}

  ngOnInit(): void {
    this.prorrogasForm.get('fec_inicio').setValue(this.contrato_serv.fec_inicio_prorroga);
    this.prorrogasForm.get('fec_fin').setValue(this.contrato_serv.fec_fin_prorroga);

    this.recurso += this.contrato_serv.json_contrato.id_contrato;
    this.params = {ind_prorroga : 1};

    if(this.contrato_serv.disabled){
      this.prorrogasForm.disable();
    }
  }

  onSubmit() {
    this.contrato_serv.fec_fin_prorroga = this.prorrogasForm.get('fec_fin').value;
    this.contrato_serv.dialog_prorrogas.close();
  }

  cancelar(){
    this.contrato_serv.fec_fin_prorroga = null;
    this.contrato_serv.dialog_prorrogas.close();
  }
}
